// constants
import { showSuccessAlert } from "../../constants/alerts";
import { CurrencyActionTypes } from "./constants";

const INIT_STATE = {
  currency: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface currencyData {
  id: string;
  currency_name: string;
  currency_flag: string;
  currency_code: string;
  currency_rate: string;
}

interface CurrencyActionType {
  type:
    | CurrencyActionTypes.API_RESPONSE_SUCCESS
    | CurrencyActionTypes.API_RESPONSE_ERROR
    | CurrencyActionTypes.CREATE_CURRENCY
    | CurrencyActionTypes.UPDATE_CURRENCY
    | CurrencyActionTypes.GET_CURRENCY
    | CurrencyActionTypes.DELETE_CURRENCY;
  payload: {
    actionType?: string;
    data?: currencyData | {};
    error?: string;
    currency?: [];
  };
}

interface State {
  currency?: currencyData[] | [];
  loading?: boolean;
  value?: boolean;
}

const Currency = (
  state: State = INIT_STATE,
  action: CurrencyActionType
): any => {
  switch (action.type) {
    case CurrencyActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case CurrencyActionTypes.CREATE_CURRENCY: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CurrencyActionTypes.GET_CURRENCY: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            currency: action.payload.data,
          };
        }
        case CurrencyActionTypes.UPDATE_CURRENCY: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case CurrencyActionTypes.DELETE_CURRENCY: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case CurrencyActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case CurrencyActionTypes.CREATE_CURRENCY: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case CurrencyActionTypes.UPDATE_CURRENCY: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case CurrencyActionTypes.GET_CURRENCY: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case CurrencyActionTypes.DELETE_CURRENCY: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case CurrencyActionTypes.CREATE_CURRENCY:
      return { ...state, loading: true };
    case CurrencyActionTypes.UPDATE_CURRENCY:
      return { ...state, loading: true };
    case CurrencyActionTypes.GET_CURRENCY:
      return { ...state, loading: true, initialLoading: true };
    case CurrencyActionTypes.DELETE_CURRENCY:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default Currency;
